import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { GetFinancialAccountUseCase } from './GetFinancialAccountUseCase'

export const getFinancialAccountUseCase = new GetFinancialAccountUseCase({
  financialAccountRepository,
}).execute
